/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminMatchingFunnelStageDto { 
    /**
     * Stable identifier of the stage, for the frontend to key on.
     */
    key: object;
    /**
     * Number of distinct people who reached this stage.
     */
    count: number;
    /**
     * Share of the first stage, 0-100 with one decimal. Always relative to sign-ups, so stages can be compared against each other.
     */
    shareOfBase: number;
    /**
     * Share of the previous stage, 0-100 with one decimal. Null on the first stage. This is the drop-off rate, and the number worth acting on.
     */
    shareOfPrevious: number | null;
}

